package org.example.project.screens_sys

import kotlinx.browser.window
import kotlinx.coroutines.await
import kotlinx.serialization.builtins.ListSerializer
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.example.project.manager.LumaticaApiManager
import org.example.project.manager.LumaticaApiSettings
import org.example.project.service.ServiceDocumentViewerService
import org.example.project.utils.All
import org.w3c.fetch.RequestInit
import org.w3c.files.File

object EingangsbelegeApi {
    private val json = Json { ignoreUnknownKeys = true; encodeDefaults = false }

    suspend fun loadBelege(): List<All> = decodeList(LumaticaApiManager.call("eingangsbelege/list"))

    suspend fun processEingang() {
        LumaticaApiManager.postJson("eingangsbelege/process-eingang", "{}")
    }

    suspend fun loadPositionen(belegId: String): List<All> =
        decodeList(LumaticaApiManager.call("eingangsbelege/positions/${part(belegId)}"))

    suspend fun loadMonate(): List<All> =
        decodeList(LumaticaApiManager.call("eingangsbelege/months"))

    suspend fun loadMonatsbelege(monat: String): List<All> =
        decodeList(LumaticaApiManager.call("eingangsbelege/month/${part(monat)}"))

    suspend fun saveBeleg(beleg: All): All? =
        runCatching {
            json.decodeFromString(All.AllNames.serializer(),
                LumaticaApiManager.postJson("eingangsbelege/save", json.encodeToString(All.AllNames.serializer(), beleg))
            )
        }.getOrNull()

    suspend fun savePositionen(belegId: String, rows: List<All>): Boolean {
        val raw = LumaticaApiManager.postJson(
            "eingangsbelege/save-positions/${part(belegId)}",
            json.encodeToString(ListSerializer(All.AllNames.serializer()), rows)
        )
        return raw.contains("\"receipt\"")
    }

    suspend fun deleteBeleg(belegId: String): Boolean =
        LumaticaApiManager.postJson("eingangsbelege/delete/${part(belegId)}", "{}")
            .contains("\"ok\":true")

    suspend fun uploadPdf(belegId: String, file: File): Boolean {
        val headers = LumaticaApiManager.auditHeaders("application/pdf").apply { append("x-file-name", file.name) }
        val response = window.fetch(
            "${LumaticaApiSettings.getBaseUrl()}/api/eingangsbelege/upload-pdf/${part(belegId)}",
            RequestInit(method = "POST", headers = headers, body = file)
        ).await()
        return response.ok
    }

    suspend fun openPdf(belegId: String, fileName: String): Boolean {
        val response = window.fetch(
            "${LumaticaApiSettings.getBaseUrl()}/api/eingangsbelege/pdf/${part(belegId)}",
            RequestInit(method = "GET", headers = LumaticaApiManager.auditHeaders())
        ).await()
        if (!response.ok) return false
        val file = response.blob().await()
        val blobUrl = window.asDynamic().URL.createObjectURL(file) as String
        ServiceDocumentViewerService.show(fileName.ifBlank { "Beleg.pdf" }, blobUrl)
        return true
    }

    private fun decodeList(raw: String): List<All> =
        runCatching { json.decodeFromString(ListSerializer(All.AllNames.serializer()), raw) }.getOrDefault(emptyList())

    private fun part(value: String): String = js("encodeURIComponent")(if (value.isBlank()) "~" else value) as String
}
